import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from '@chakra-ui/react';
import { useMutation } from 'react-query';
import { mutateFunction } from '../../../../libs/apis';
import { CustomToast } from '../../../toast/CustomToast';

const DeleteEventModal = ({ isOpen, onClose, event, onSuccess }) => {
  const { addToast } = CustomToast();

  const { mutate, isLoading } = useMutation(mutateFunction);

  const handleDelete = () => {
    mutate(
      {
        key: `admins/events/${event.id}`,
        method: 'delete',
      },
      {
        onSuccess: (res) => {
          addToast(res);
          onSuccess();
        },
        onError: (error) => {
          addToast(
            error?.response?.data?.message || 'Error deleting event.',
            'error',
          );
        },
      },
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent
        w={{ base: '90%', md: '500px' }}
        maxW={{ base: '90%', md: '500px' }}
        maxH="90vh"
        overflow="hidden"
      >
        <ModalHeader>Delete Event</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete the event "{event?.name}"?
          </Text>
          <Text mt={2} color="gray.600">
            This action cannot be undone.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={handleDelete}
            isLoading={isLoading}
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteEventModal;
